import { render, staticRenderFns } from "./PromiseConfig.vue?vue&type=template&id=703f2a55&scoped=true"
import script from "./PromiseConfig.vue?vue&type=script&lang=js"
export * from "./PromiseConfig.vue?vue&type=script&lang=js"
import style0 from "./PromiseConfig.vue?vue&type=style&index=0&id=703f2a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f2a55",
  null
  
)

export default component.exports